// Auto-formatting for payment and phone inputs.
// Targets: [data-format="card-number"], [data-format="expiry"],
//          [data-format="phone"], [data-format="zip"]

import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

function digitsOnly(v) {
  return v.replace(/\D/g, "");
}

function formatCardNumber(input) {
  const raw = digitsOnly(input.value).slice(0, 16);
  input.value = raw.replace(/(.{4})/g, "$1 ").trim();
}

function formatExpiry(input) {
  const raw = digitsOnly(input.value).slice(0, 4);
  if (raw.length >= 3) {
    input.value = raw.slice(0, 2) + " / " + raw.slice(2);
  } else {
    input.value = raw;
  }
}

function formatPhone(input) {
  const raw = digitsOnly(input.value).slice(0, 11);

  if (raw.length === 0) {
    input.value = "";
    return;
  }

  // Handle +1 prefix
  let digits = raw;
  let prefix = "";
  if (digits.length > 10) {
    prefix = "+" + digits.slice(0, digits.length - 10) + " ";
    digits = digits.slice(digits.length - 10);
  } else if (digits.length === 11 && digits.startsWith("1")) {
    prefix = "+1 ";
    digits = digits.slice(1);
  }

  if (digits.length <= 3) {
    input.value = prefix + "(" + digits;
  } else if (digits.length <= 6) {
    input.value = prefix + "(" + digits.slice(0, 3) + ") " + digits.slice(3);
  } else {
    input.value =
      prefix +
      "(" +
      digits.slice(0, 3) +
      ") " +
      digits.slice(3, 6) +
      "-" +
      digits.slice(6);
  }
}

function formatZip(input) {
  const raw = digitsOnly(input.value).slice(0, 9);
  if (raw.length > 5) {
    input.value = raw.slice(0, 5) + "-" + raw.slice(5);
  } else {
    input.value = raw;
  }
}

const formatters = {
  "card-number": formatCardNumber,
  expiry: formatExpiry,
  phone: formatPhone,
  zip: formatZip,
};

export function initInputFormat(root = document) {
  const inputs = root.querySelectorAll("[data-format]");

  inputs.forEach((input) => {
    if (!firstBind(input)) return;

    const formatter = formatters[input.dataset.format];
    if (!formatter) return;

    input.addEventListener("input", () => {
      const pos = input.selectionStart;
      const before = input.value.length;
      formatter(input);
      const after = input.value.length;
      // Adjust cursor for inserted separators
      const newPos = pos + (after - before);
      input.setSelectionRange(newPos, newPos);
    });
  });
}
